const {
  lineString,
  featureCollection,
} = require('@turf/turf');
import length from '@turf/length';
import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useFluent from '../../../hooks/useFluent';
import useMapContext from '../../../hooks/useMapContext';
import { routePlanLink } from '../../../routing/Utils';
import { primaryColor } from '../../../styling/styleUtils';
import { Coordinate, Trail } from '../../../types/graphQLTypes';
import { buildNetwork } from '../../template/globalMap/map/interactions/routePlanning/routeWorker';
import useEditPoint from '../../template/globalMap/map/interactions/routePlanning/useEditPoints';
import { defaultGeoJsonLineString, defaultGeoJsonPoint, segmentMarkerLayerId } from '../../template/globalMap/map/layers';

interface Props {
  id: Trail['id'];
  name: Trail['name'];
  type: Trail['type'];
  line: Trail['line'];
  center: Trail['center'];
}

const TrailToRoute = (props: Props) => {
  const {
    id, name, type, line, center,
  } = props;
  const getString = useFluent();
  const history = useHistory();
  const mapContext = useMapContext();
  useEffect(() => {
    buildNetwork(center);
  }, [center]);
  useEffect(() => {
    if (mapContext.intialized && line) {
      mapContext.setHighlightedTrails(
        featureCollection([
          lineString(line, {
            hashKey: id, color: primaryColor, index: 0,
          }),
        ]), true,
      );
    }
    return () => {
      if (mapContext.intialized) {
        mapContext.setHighlightedTrails(defaultGeoJsonLineString);
        const highlightedTrailMileMarkersSource = mapContext.map.getSource(segmentMarkerLayerId) as any;
        highlightedTrailMileMarkersSource.setData(defaultGeoJsonPoint);
      }
    };
  }, [mapContext, line, id]);
  useEditPoint({
    segments: [{
      name: name ? name : upperFirst(getString('global-formatted-trail-type', {type})),
      color: primaryColor,
      lines: [line],
      trails: [{
        name,
        type,
        id,
      }],
      hashKey: id,
    }],
    onComplete: (updatedSegments) => {
      history.push({
        pathname: routePlanLink(),
        state: {
          routePlan: {
            id: null,
            name: 'Hike on ' + (name ? name : getString('global-formatted-trail-type', {type})),
            visibility: 'public',
            autoGenerated: false,
            authors: [],
            authorVisibility: 'public',
            totalLength: length(lineString(updatedSegments[0].lines[0]), {units: 'miles'}),
            date: new Date(),
            segments: updatedSegments.map(segment => ({
              name: segment.name,
              color: segment.color,
              lines: segment.lines.map(l => l.map(coord => coord.map(point => point))) as Coordinate[][],
              trails: segment.trails,
              hashKey: segment.hashKey,
            })),
            center,
          },
        },
      });
    },
  });

  return <React.Fragment />;
};

export default TrailToRoute;
